module.exports = __webpack_public_path__ + "img/sy-pic2.a2b197ab.png";